"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _question = _interopRequireDefault(require("./question.svg"));
var _cccisdFormik = require("cccisd-formik");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Information = /*#__PURE__*/function (_React$Component) {
  _inherits(Information, _React$Component);
  function Information() {
    var _this;
    _classCallCheck(this, Information);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Information, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getInitialValues", function () {
      var meta = _this.props.meta;
      return meta.information ? {
        information: meta.information.text
      } : {};
    });
    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      var information = values.information;
      var meta = information ? _objectSpread(_objectSpread({}, _this.props.meta), {}, {
        information: {
          text: information
        }
      }) : (0, _omit2["default"])(_this.props.meta, 'information');
      _this.props.setContent(_this.props.content, meta);
    });
    _defineProperty(_assertThisInitialized(_this), "removeInformation", function () {
      _this.props.setContent(_this.props.content, (0, _omit2["default"])(_this.props.meta, 'information'));
    });
    return _this;
  }
  _createClass(Information, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var initialValues = this.getInitialValues();
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: initialValues,
        onSubmit: this.onSubmit,
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "information",
            component: _cccisdFormik.CccisdTextarea,
            label: "Tooltip",
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Submit"), initialValues.information && /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-warning",
            type: "button",
            onClick: _this2.removeInformation
          }, "Remove tooltip")));
        }
      });
    }
  }]);
  return Information;
}(_react["default"].Component);
_defineProperty(Information, "propTypes", {
  insertContent: _propTypes["default"].func,
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  selectedContent: _propTypes["default"].string
});
var _default = exports["default"] = {
  name: 'cccisdInformation',
  tooltip: 'Tooltip at the end',
  image: _question["default"],
  title: 'Tooltip at the end',
  component: Information,
  activeCondition: function activeCondition(element, meta) {
    return meta && meta.information;
  }
};